// VEPC Gestao - Central Administrativa: Tela de Aplicativo e Infraestrutura
import { api } from '../api.js';

export async function renderInfra() {
  const container = document.createElement('div');
  container.className = 'view-content';

  container.innerHTML = `
    <div class="view-header">
      <div class="view-title-group">
        <h2>Aplicativo & Infraestrutura</h2>
        <p>Monitoramento verificável dos serviços, canais de atualização do Android e histórico técnico.</p>
      </div>
      <div class="view-actions">
        <button class="btn btn-primary" id="btn-executar-diag">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
          Executar Diagnóstico Verificável
        </button>
      </div>
    </div>

    <!-- Regra Inegociável -->
    <div class="alert-box alert-info">
      <svg class="alert-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
      <div>
        <strong>Princípio de Verificabilidade Estrita:</strong>
        Nenhum serviço é exibido como conectado ou saudável sem confirmação técnica verificável. Integrações com pendências (WhatsApp e IA) são explicitadas sem suposições.
      </div>
    </div>

    <!-- Grid de Serviços -->
    <div class="card-panel">
      <div class="panel-header">
        <span class="panel-title">Estado Verificável dos Componentes</span>
        <button class="btn btn-secondary btn-sm" id="btn-retestar-infra">Retestar Agora</button>
      </div>
      <div class="panel-body" id="painel-servicos-infra">
        <div style="padding: 20px; text-align: center; color: var(--vepc-text-muted);">Verificando conexões técnicas...</div>
      </div>
    </div>

    <!-- Versões do Aplicativo e Histórico -->
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
      <!-- Versões Android -->
      <div class="card-panel">
        <div class="panel-header">
          <span class="panel-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/></svg>
            Versões Registradas do App Android
          </span>
        </div>
        <div class="panel-body" style="padding: 0;">
          <div class="table-responsive">
            <table class="data-table" style="font-size: 12.5px;">
              <thead>
                <tr>
                  <th>Canal</th>
                  <th>Versão</th>
                  <th>Status</th>
                  <th>Fonte</th>
                </tr>
              </thead>
              <tbody id="corpo-versoes-app">
                <tr><td colspan="4" style="text-align: center; padding: 20px;">Carregando versões...</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Histórico Técnico da Infraestrutura -->
      <div class="card-panel">
        <div class="panel-header">
          <span class="panel-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            Histórico Técnico de Atualizações
          </span>
        </div>
        <div class="panel-body" id="corpo-historico-tecnico" style="padding: 16px; display: flex; flex-direction: column; gap: 12px; max-height: 380px; overflow-y: auto;">
          <div style="text-align: center; color: var(--vepc-text-muted);">Carregando histórico técnico...</div>
        </div>
      </div>
    </div>

    <div id="modal-container-diag"></div>
  `;

  const painelServicos = container.querySelector('#painel-servicos-infra');
  const corpoVersoes = container.querySelector('#corpo-versoes-app');
  const corpoHistorico = container.querySelector('#corpo-historico-tecnico');
  const modalContainer = container.querySelector('#modal-container-diag');

  async function carregarInfra() {
    try {
      const data = await api.getInfraStatus();
      const s = data.servicos;

      painelServicos.innerHTML = `
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 16px;">
          <!-- Banco D1 Admin -->
          <div style="border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 16px; background: #FAFCFE;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <span style="font-weight: 700; font-size: 13.5px; color: var(--vepc-azul-institucional);">Banco D1 (ADMIN_DB)</span>
              <span class="badge ${s.d1_admin.conectado ? 'badge-sucesso' : 'badge-vencida'}">
                ${s.d1_admin.conectado ? 'CONECTADO' : 'FALHA'}
              </span>
            </div>
            <div style="font-size: 12px; color: var(--vepc-text-muted);">${s.d1_admin.mensagem}</div>
            <div style="font-family: var(--font-mono); font-size: 11px; color: var(--vepc-text-subtle); margin-top: 6px;">
              Ping: ${s.d1_admin.latencia_ms !== null ? s.d1_admin.latencia_ms + 'ms' : '—'} &bull; Verificado em tempo real
            </div>
          </div>

          <!-- Worker Móvel do Aplicativo -->
          <div style="border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 16px; background: #FAFCFE;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <span style="font-weight: 700; font-size: 13.5px; color: var(--vepc-azul-institucional);">Worker App (vepc-gestao-mobile-dev)</span>
              <span class="badge badge-avaliacao">PRESERVADO</span>
            </div>
            <div style="font-size: 12px; color: var(--vepc-text-muted);">${s.app_worker.detalhes}</div>
            <div style="font-family: var(--font-mono); font-size: 11px; color: var(--vepc-text-subtle); margin-top: 6px;">
              Endpoint: ${s.app_worker.url}
            </div>
          </div>

          <!-- Firebase Authentication -->
          <div style="border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 16px; background: #FAFCFE;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <span style="font-weight: 700; font-size: 13.5px; color: var(--vepc-azul-institucional);">Firebase Authentication</span>
              <span class="badge badge-aberto">LOCAL-DEMO</span>
            </div>
            <div style="font-size: 12px; color: var(--vepc-text-muted);">${s.firebase_auth.detalhes}</div>
            <div style="font-family: var(--font-mono); font-size: 11px; color: var(--vepc-text-subtle); margin-top: 6px;">
              Project: ${s.firebase_auth.project_id}
            </div>
          </div>

          <!-- WhatsApp Oficial -->
          <div style="border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 16px; background: #FFF5F5;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <span style="font-weight: 700; font-size: 13.5px; color: var(--vepc-danger);">Integração WhatsApp</span>
              <span class="badge badge-vencida">NÃO CONECTADO</span>
            </div>
            <div style="font-size: 12px; color: #7F1D1D;">${s.integracoes.whatsapp.motivo}</div>
            <div style="font-size: 11px; font-weight: 700; color: #991B1B; margin-top: 6px;">
              Nenhum número ou canal oficial conectado.
            </div>
          </div>

          <!-- Assistente com IA -->
          <div style="border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 16px; background: #FEFCE8;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
              <span style="font-weight: 700; font-size: 13.5px; color: #854D0E;">Assistente com IA</span>
              <span class="badge badge-pendente">HOMOLOGAÇÃO</span>
            </div>
            <div style="font-size: 12px; color: #713F12;">${s.integracoes.ia.motivo}</div>
            <div style="font-size: 11px; font-weight: 700; color: #854D0E; margin-top: 6px;">
              Apenas dados simulados no ambiente local.
            </div>
          </div>
        </div>
      `;
    } catch (err) {
      painelServicos.innerHTML = `<div style="color: var(--vepc-danger); padding: 20px;">Falha ao checar infra: ${err.message}</div>`;
    }

    // Carrega Versões
    try {
      const vData = await api.getVersoesApp();
      corpoVersoes.innerHTML = (vData.versoes || []).map(v => `
        <tr>
          <td><span class="badge badge-avaliacao">${v.canal}</span></td>
          <td><strong>${v.version_name}</strong> (v${v.version_code})</td>
          <td><span class="badge ${v.status === 'homologacao' ? 'badge-beta' : 'badge-sucesso'}">${v.status.toUpperCase()}</span></td>
          <td style="font-size: 11px; color: var(--vepc-text-muted);">${v.fonte}</td>
        </tr>
      `).join('');
    } catch (e) {
      corpoVersoes.innerHTML = `<tr><td colspan="4" style="color: var(--vepc-danger); padding: 10px;">Erro ao listar versões.</td></tr>`;
    }

    // Carrega Histórico Técnico
    try {
      const hData = await api.getHistoricoTecnico();
      corpoHistorico.innerHTML = (hData.historico || []).map(h => `
        <div style="border-left: 3px solid var(--vepc-azul-institucional); padding-left: 10px; font-size: 12.5px;">
          <div style="display: flex; justify-content: space-between;">
            <strong style="color: var(--vepc-azul-institucional);">${h.titulo}</strong>
            <span style="font-family: var(--font-mono); font-size: 11px; color: var(--vepc-text-muted);">${h.data_evento}</span>
          </div>
          <div style="color: var(--vepc-text-muted); margin-top: 2px;">${h.descricao}</div>
          <div style="font-size: 10.5px; color: var(--vepc-text-subtle); margin-top: 2px;">Fonte: ${h.fonte}</div>
        </div>
      `).join('');
    } catch (e) {
      corpoHistorico.innerHTML = `<div style="color: var(--vepc-danger);">Erro ao listar histórico.</div>`;
    }
  }

  // Executar Diagnóstico Verificável
  container.querySelector('#btn-executar-diag').onclick = async () => {
    try {
      const { resultado } = await api.executarDiagnostico();
      modalContainer.innerHTML = `
        <div class="modal-backdrop">
          <div class="modal-card">
            <div class="modal-header">
              <h3 style="font-size: 16px; font-weight: 800; color: var(--vepc-azul-institucional);">Resultado do Diagnóstico Técnico</h3>
              <button class="btn btn-secondary btn-sm btn-fechar-modal">&times;</button>
            </div>
            <div class="modal-body">
              <div style="background: #FAFCFE; border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 14px; margin-bottom: 16px;">
                <div style="font-size: 13px;">
                  Executado por: <strong>${resultado.operador}</strong> &bull; Duração: <strong>${resultado.duracao_ms}ms</strong>
                </div>
                <div style="font-family: var(--font-mono); font-size: 11px; color: var(--vepc-text-muted); margin-top: 2px;">
                  ${resultado.executado_em}
                </div>
              </div>

              <h4 style="font-size: 13px; font-weight: 700; margin-bottom: 8px;">Conformidade das Travas de Segurança:</h4>
              <ul style="list-style: none; font-size: 13px; display: flex; flex-direction: column; gap: 8px; margin-bottom: 16px;">
                <li>${resultado.checks.travas_seguranca.cobranca_automatica_desativada ? '✅' : '❌'} <strong>Cobrança Automática:</strong> DESLIGADA (Segurança garantida)</li>
                <li>${resultado.checks.travas_seguranca.bloqueio_automatico_desativado ? '✅' : '❌'} <strong>Bloqueio Automático de Clientes:</strong> DESLIGADO (Segurança garantida)</li>
                <li>${resultado.checks.d1_admin.ok ? '✅' : '❌'} <strong>Integridade do Banco D1:</strong> Respondendo com sucesso (${resultado.checks.d1_admin.empresas} empresas)</li>
                <li>${resultado.checks.auditoria.ok ? '✅' : '❌'} <strong>Trilha de Auditoria:</strong> Imutável e operacional (${resultado.checks.auditoria.registros} eventos registrados)</li>
              </ul>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary btn-sm btn-fechar-modal">Concluir Inspeção</button>
            </div>
          </div>
        </div>
      `;

      modalContainer.querySelectorAll('.btn-fechar-modal').forEach(b => {
        b.onclick = () => { modalContainer.innerHTML = ''; };
      });
    } catch (err) {
      alert('Erro ao executar diagnóstico: ' + err.message);
    }
  };

  container.querySelector('#btn-retestar-infra').onclick = carregarInfra;

  carregarInfra();
  return container;
}
